import type { Feedback as FeedbackType } from 'app/typings/adminBookings/bookingFeedback';
import type {
  BookingDetails,
  BookingVoucherResponse,
} from 'app/typings/core/admin/bookings/booking';

import styles from '../BookingDetails.module.scss';

import { LeftPanel } from './LeftPanel/LeftPanel';
import { RightPanel } from './RightPanel/RightPanel';

type Props = {
  bookingDetails: BookingDetails;
  bookingCode: string;
  reloadBooking: () => void;
  resendUserConfirmationMail: () => void;
  resendHotelConfirmationMail: () => void;
  onOpenRefundModal: () => void;
  onOpenVoucherModal: (voucher?: BookingVoucherResponse) => void;
  onEditFeedback: (feedback: FeedbackType) => void;
  onCancelBooking: () => void;
  onEditReview: (reviewId: number) => void;
};

export const DetailsContent = ({
  bookingDetails,
  bookingCode,
  reloadBooking,
  resendUserConfirmationMail,
  resendHotelConfirmationMail,
  onOpenRefundModal,
  onOpenVoucherModal,
  onEditFeedback,
  onCancelBooking,
  onEditReview,
}: Props) => (
  <>
    <div className={styles.bookingDetailsContent}>
      <div className={styles.leftPart}>
        <LeftPanel bookingDetails={bookingDetails} />
      </div>
      <div className={styles.rightPart}>
        <RightPanel
          bookingDetails={bookingDetails}
          bookingCode={bookingCode}
          reloadBooking={reloadBooking}
          resendUserConfirmationMail={resendUserConfirmationMail}
          resendHotelConfirmationMail={resendHotelConfirmationMail}
          onOpenRefundModal={onOpenRefundModal}
          onOpenVoucherModal={onOpenVoucherModal}
          onEditFeedback={onEditFeedback}
          onCancelBooking={onCancelBooking}
          onEditReview={onEditReview}
        />
      </div>
    </div>
  </>
);
